module.exports = new __parcel__URL__("certification.1af2dbda.jpeg").toString();